import React from "react";
import { Card, Container } from "react-bootstrap";

import "./css/SiteCircuitManagement.css";
import "./css/CircuitStyle.css";

import NewStructures2 from "./NewStructures2";
import { useSiteContext } from "./Providers/SSCProvider";

const NewStructuresDisplay = ({ headerOffset }) => {
  const { selectedSite } = useSiteContext();
  return (
    <Card
      style={{
        marginTop: headerOffset + 25,
      }}
    >
      <Card.Body className="m-0 p-0 pb-1">
        <Container fluid className="mt-4 p-0">
          {selectedSite?.structures
            ?.filter((s) => s.circuits?.length > 0)
            .sort((a, b) => {
              const aHasNew = a.circuits.some((c) => c.isNew);
              const bHasNew = b.circuits.some((c) => c.isNew);

              if (aHasNew && !bHasNew) return -1;
              if (!aHasNew && bHasNew) return 1;

              if (a.tempStructure && !b.tempStructure) return -1;
              if (!a.tempStructure && b.tempStructure) return 1;

              return a.structureId - b.structureId;
            })
            .map((structure, index) => (
              <NewStructures2 key={index} thisStructure={structure} />
            ))}
        </Container>
      </Card.Body>
    </Card>
  );
};

export default NewStructuresDisplay;
